import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';

const GoogleAnalytics = React.lazy(() => import('./GoogleAnalytics'));

export default class GoogleAnalyticsWrapper extends Component {
  render() {
    return (
      <div>
        <Suspense>
          <GoogleAnalytics
            config={this.props.config}
            reportEvent={this.props.reportEvent(this.props.config.id)}
          />
        </Suspense>
      </div>
    );
  }
}

GoogleAnalyticsWrapper.propTypes = {
  config: PropTypes.object.isRequired,
};
